export const DAY_DATE_FORMAT = "YYYY-MM-DD";

// we do not deal with seconds (makes it harder to cover shifts exactly, as we would need input controls for seconds)
export const DAY_DATETIME_FORMAT = "YYYY-MM-DD[T]HH:mm";

// we do not deal with seconds (makes it harder to cover shifts exactly, as we would need input controls for seconds)
export const DAY_TIME_FORMAT = "HH:mm";

export const VISUAL_DATE_FORMAT = "DD.MM.YYYY";
export const VISUAL_DATETIME_FORMAT = "DD.MM.YYYY HH:mm";
export const VISUAL_TIME_FORMAT = "HH:mm";
export const VISUAL_TIME_FORMAT_DAY = "ddd";

export const VISUAL_DATE_FORMAT_W_SLASH = "DD/MM/YYYY";
export const CLEAN_DATE_FORMAT = "YYYYMMDD";
export const CLEAN_VISUAL_DATE_FORMAT = "DDMMYYYY";
